module.exports = __webpack_public_path__ + "static/media/loading.34eee1e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/loading.svg
// module id = 116
// module chunks = 0